module.exports = __webpack_public_path__ + "static/media/ad.80020733.svg";